import { Component, OnInit } from '@angular/core';
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {DialogModel} from "@shared/models/dialog.model";

@Component({
    standalone: false,
    selector: 'particle-edit-date-settings-dialog-editor',
  templateUrl: './edit-date-settings-dialog-editor.component.html',
  styleUrls: ['./edit-date-settings-dialog-editor.component.scss']
})
export class EditDateSettingsDialogEditorComponent implements OnInit, IDialogView {

  constructor() { }
  data: DialogModel;

  unitValues: any;
  unitTypes: any;

  ngOnInit(): void {
    this.unitValues = this.getUnitValues();
    this.unitTypes = this.getUnitTypes();
  }

  getUnitValues(): any{
    return Array.from(Array(30), (_, index) => index + 1);
  }

  getUnitTypes(): any{
    return ['Day', 'Week', 'Month'];
  }

  onOkClicked(): any {
    return true;
  }

}
